import React, { Component, createRef } from 'react';
import { Icon } from 'antd';
import classnames from 'classnames';
import { ImageUpload } from '@comall-backend-builder/components-basis';
import { utils } from '../../../services/utils';
import './index.less';

/**
 * 单选图片
 */
export class UploadPicture extends Component<{
    value?: any;
    className?: string;
    uploadAction: string;
    sourceRoot: { image?: string };
    uploadText?: string;
    maxSize?: number;
    previewMode?: 'default' | 'hover-actions';
    onChange?: (value: any) => void;
}> {
    uploadContainerRef = createRef<HTMLDivElement>();

    state = {
        uploadLoading: false,
    };

    triggerUpload = () => {
        const container = this.uploadContainerRef.current;
        if (!container) return;
        const input = container.querySelector('input[type="file"]') as HTMLInputElement | null;
        if (input) {
            input.click();
        }
    };

    handleDelete = (event) => {
        event.stopPropagation();
        const { onChange } = this.props;
        onChange && onChange(undefined);
    };

    handleReplace = (event) => {
        event.stopPropagation();
        this.triggerUpload();
    };

    getUploadProps() {
        const { value, uploadAction, className, maxSize, onChange } = this.props;
        return {
            value,
            name: 'fileName',
            fileName: 'fileName',
            className: classnames('item-uploader', className),
            showUploadList: false,
            uploadType: 'single',
            mode: 'picture-card',
            accept: 'image/*',
            uploadUrl: uploadAction,
            maxCount: 1,
            preview: {
                type: 'popover',
                src: value,
            },
            uploadCompleteMessage: null,
            maxSize,
            onChange: (v: any) => {
                if (v && v.length > 0) {
                    onChange && onChange(v[0].path);
                } else {
                    onChange && onChange(v);
                }
                return {};
            },
        };
    }

    renderHiddenUploader() {
        return (
            <div className="picture-box__uploader-hidden" ref={this.uploadContainerRef}>
                <ImageUpload {...this.getUploadProps()} listType="picture-card" />
            </div>
        );
    }

    renderHoverActionsPreview() {
        const { value, sourceRoot, uploadText } = this.props;

        if (!value) {
            return (
                <div className="picture-box picture-box--hover-actions">
                    <div
                        className="image-upload-box"
                        role="button"
                        tabIndex={0}
                        onClick={this.triggerUpload}
                        onKeyPress={(event) => {
                            if (event.key === 'Enter') {
                                this.triggerUpload();
                            }
                        }}
                    >
                        <span className="upload-plus">+</span>
                        <span className="upload-text">{uploadText || '上传'}</span>
                    </div>
                    {this.renderHiddenUploader()}
                </div>
            );
        }

        return (
            <div className="picture-box picture-box--hover-actions">
                <div className="image-preview-box">
                    <img
                        className="image-preview"
                        src={utils.formatImageUrl(sourceRoot, value)}
                        alt="item-pic"
                    />
                    <div className="image-preview-mask">
                        <button type="button" className="mask-btn" onClick={this.handleReplace}>
                            更换
                        </button>
                        <button type="button" className="mask-btn" onClick={this.handleDelete}>
                            删除
                        </button>
                    </div>
                </div>
                {this.renderHiddenUploader()}
            </div>
        );
    }

    renderDefaultPreview() {
        const { value, sourceRoot, uploadText } = this.props;
        const uploadButton = (
            <div>
                <Icon type={this.state.uploadLoading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">{uploadText || '上传'}</div>
            </div>
        );

        return (
            <div className="picture-box">
                <ImageUpload {...this.getUploadProps()} listType="picture-card">
                    {value ? (
                        <img
                            className="item-img"
                            src={utils.formatImageUrl(sourceRoot, value)}
                            alt="item-pic"
                        />
                    ) : (
                        uploadButton
                    )}
                </ImageUpload>
            </div>
        );
    }

    render() {
        const { previewMode = 'default' } = this.props;
        if (previewMode === 'hover-actions') {
            return this.renderHoverActionsPreview();
        }
        return this.renderDefaultPreview();
    }
}
